import { render, staticRenderFns } from "./UnderPerf.vue?vue&type=template&id=ed9d795c&scoped=true"
import script from "./UnderPerf.vue?vue&type=script&lang=js"
export * from "./UnderPerf.vue?vue&type=script&lang=js"
import style0 from "./UnderPerf.vue?vue&type=style&index=0&id=ed9d795c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9d795c",
  null
  
)

export default component.exports